

<div nxLayout="grid" class="nx-margin-top-2m">
  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12,10">
      <div nxLayout="grid" class="nx-margin-top-s">
        <div nxRow>
          <div nxCol="2">
            <nx-formfield>
              <input nxInput placeholder="Enter Keyword" [(ngModel)]="searchTerm" type="search" />
              <span nxFormfieldPrefix><nx-icon name="search" size="s"></nx-icon></span>
              <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm = ''; getAllClaims()">
                <nx-icon name="close" size="s"></nx-icon>
              </span>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Claim Status">
              <nx-dropdown [(ngModel)]="SelectedClaimStatus" [nxIsMultiselect]="true">
                <nx-dropdown-item *ngFor="let type of claimStatusList" [nxValue]="ClaimStatuses[type]">{{ type }}</nx-dropdown-item>
              </nx-dropdown>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="Start Date">
              <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="startDate" />
              <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #startDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="2">
            <nx-formfield nxLabel="End Date">
              <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="endDate" />
              <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #endDatepicker></nx-datepicker>
            </nx-formfield>
          </div>

          <div nxCol="4" style="display:flex; gap:8px; align-items:flex-end; flex-wrap:wrap; padding-bottom:24px;">
            <button nxButton="primary small-medium" type="button" (click)="getAllClaims()">Search</button>
            <button nxButton="secondary small-medium" type="button" (click)="exportToExcel()">
              <nx-icon name="file-spreadsheet" class="nx-margin-right-2xs"></nx-icon>Export
            </button>       
          </div>
        </div>
        <div nxRow nxRowJustify="end">
        <div nxCol="12" style="text-align: right;">
              <button nxButton="secondary small-medium" type="button" *ngIf="isDealer" (click)="toggleClaimFormModal()">
              <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>Submit Claim
            </button>
            <button nxButton="secondary small-medium" type="button" *ngIf="isDealer" (click)="openCasesModal()" class="nx-margin-left-s">
              Technician Support History
            </button>
        </div>
        </div>s
      </div>
    </div>
  </div>

  <div nxRow nxRowJustify="start,start,around">
    <div nxCol="12,10" *ngIf="count != 0">
      <table nxTable zebra condensed nxSort (sortChange)="sortTable($event)" class="nx-margin-top-s">
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="submissionDate">Submission Date</th>
            <th nxHeaderCell nxSortHeaderCell="claimType">Claim Type</th>
            <th nxHeaderCell *ngIf="!isDealer" nxSortHeaderCell="dealerCode">Dealer Code</th>
            <th nxHeaderCell *ngIf="!isDealer" nxSortHeaderCell="dealerName">Dealer Name</th>
            <th nxHeaderCell nxSortHeaderCell="remark">Remark</th>
            <th nxHeaderCell nxSortHeaderCell="approvedRemarks">AWP Remarks</th>
            <th nxHeaderCell nxSortHeaderCell="approvedDate">Approved Date</th>
            <th nxHeaderCell nxSortHeaderCell="status">Status</th>
            <th nxHeaderCell>Invoice</th>
            <th nxHeaderCell *ngIf="userPermission.approveReject">Actions</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let claim of claimList">
            <td nxTableCell>{{ claim.submissionDate | date: 'dd/MM/yyyy' }}</td>
            <td nxTableCell>{{ getClaimTypeName(claim.claimType) }}</td>
            <td nxTableCell *ngIf="!isDealer">{{ claim.dealerCode }}</td>
            <td nxTableCell *ngIf="!isDealer">{{ claim.dealerName }}</td>
            <td nxTableCell>{{ claim.remark }}</td>
            <td nxTableCell>{{ claim.approvedRemarks }}</td>
            <td nxTableCell>{{ claim.approvedDate | date: 'dd/MM/yyyy' }}</td>
            <td nxTableCell>
              <nx-badge *ngIf="claim.status == ClaimStatuses.Paid" type="positive">Paid</nx-badge>
              <nx-badge *ngIf="claim.status == ClaimStatuses.UnderProcess" type="active">Under Process</nx-badge>
              <nx-badge *ngIf="claim.status == ClaimStatuses.Rejected" type="critical">Rejected</nx-badge>
            </td>
            <td nxTableCell>
              <button nxIconButton="tertiary small" type="button" *ngIf="claim.invoicePdfPath"
                (click)="download(claim.invoicePdfPath)" nxTooltip="Download Invoice" nxTooltipPosition="top">
                <nx-icon name="download"></nx-icon>
              </button>
            </td>
            <td nxTableCell *ngIf="userPermission.approveReject">
              <nx-context-menu #menu="nxContextMenu">
                <ng-template nxContextMenuContent>
                  <button type="button" nxContextMenuItem
                    [disabled]="claim.status !== ClaimStatuses.UnderProcess"
                    (click)="toggleApproveRejectModal(true, claim)">
                    <nx-icon name="checkmark-circle-o" class="nx-margin-right-2xs"></nx-icon>Approve
                  </button>
                  <button type="button" nxContextMenuItem
                    [disabled]="claim.status !== ClaimStatuses.UnderProcess"
                    (click)="toggleApproveRejectModal(false, claim)">
                    <nx-icon name="close-circle-o" class="nx-margin-right-2xs"></nx-icon>Reject
                  </button>
                </ng-template>
              </nx-context-menu>
              <button nxIconButton="tertiary medium" type="button" [nxContextMenuTriggerFor]="menu"
                aria-label="Open menu" nxTooltip="Actions" nxTooltipPosition="top">
                <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div nxRow class="nx-margin-top-2m nx-margin-right-xl" style="float: right">
        <div nxCol="6">
          <nx-pagination [nxCount]="count" [nxPage]="pageNumber" [nxPerPage]="pageSize" nxType="advanced"
            (nxGoPrev)="prevPage()" (nxGoNext)="nextPage()" (nxGoPage)="goToPage($event)">
          </nx-pagination>
        </div>
      </div>
    </div>

    <div nxCol="12,10" class="nx-margin-top-2xl" *ngIf="count == 0">
      <ng-container>
        <div nxRow nxRowJustify="center">
          <div nxCol="12" class="nosearchresult"></div>
          <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found !!!</h3>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Approve / Reject Modal -->
<nx-modal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="claimViewModalOpen" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="!isSuccess" style="margin-top: 2%">
    <div nxRow nxRowJustify="start,around">
      <h3 nxHeadline="subsection-xsmall" *ngIf="reqDecision">Approve Claim</h3>
      <h3 nxHeadline="subsection-xsmall" *ngIf="!reqDecision">Reject Claim</h3>
    </div>
    <form [formGroup]="claimApproveRejectForm">
      <div nxRow>
        <div nxCol="12,12,6,4">
          <nx-formfield nxLabel="Claim Type">
            <input nxInput [value]="getClaimTypeName(selectedClaim.claimType)" readonly />
          </nx-formfield>
        </div>
        <div nxCol="12,12,6,4">
          <nx-formfield nxLabel="Dealer Remark">
            <textarea nxInput formControlName="remark" rows="2" cols="40" readonly></textarea>
          </nx-formfield>
        </div>
        <div nxCol="12,12,6,4">
          <nx-formfield nxLabel="Submission Date">
            <input nxInput [value]="selectedClaim.submissionDate | date: 'dd/MM/yyyy'" readonly />
          </nx-formfield>
        </div>
      </div>
      <div nxRow>
        <div nxCol="12,12,6,4" *ngIf="selectedClaim.invoicePdfPath">
          <h4><strong>Invoice</strong></h4>
          <nx-icon name="pdf" class="nx-margin-right-2xs" size="m" style="color: red"></nx-icon>
          <span style="vertical-align: top">{{ selectedClaim.invoicePdfPath?.split('_')[1] }}</span>
          <button nxButton="tertiary small" type="button" (click)="download(selectedClaim.invoicePdfPath)">
            <nx-icon name="launch" class="nx-margin-right-2xs"></nx-icon>Open
          </button>
        </div>
        <div nxCol="12,12,6,4" *ngIf="selectedClaim.vehicleImagePaths && selectedClaim.claimType == ClaimTypes.Damage">
          <h4><strong>Vehicle Images</strong></h4>
          <span *ngFor="let img of selectedClaim.vehicleImagePaths?.split(',')">
            <button nxButton="tertiary small" type="button" (click)="download(img)">
              <nx-icon name="img" class="nx-margin-right-2xs"></nx-icon>View
            </button>
          </span>
        </div>
      </div>
      <div nxRow>
        <div nxCol="12">
          <nx-formfield nxLabel="AWP Remarks">
            <textarea nxInput formControlName="approvedRemarks" rows="2" cols="65" type="text" required></textarea>
            <nx-error nxFormfieldError>
              <div *ngIf="ARFormControls.approvedRemarks.errors?.required"><strong>Please note:</strong> Enter remark.</div>
              <div *ngIf="ARFormControls.approvedRemarks.errors?.pattern"><strong>Please note:</strong> Enter valid remark.</div>
            </nx-error>
          </nx-formfield>
        </div>
      </div>
      <div nxRow>
        <div nxCol="10" nxColOffset="1" style="text-align: center" class="nx-margin-top-2m">
          <button nxButton="primary" type="button" (click)="saveClaimDecision()" [disabled]="checkSaveDisable">
            {{ saveClaimText }}
            <nx-spinner nxSize="medium" class="nx-margin-x-2xs" *ngIf="saveClaimInProgress"></nx-spinner>
          </button>
          <button nxButton="emphasis" type="button" (click)="toggleClaimARModal()">Cancel</button>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="isSuccess">
    <div nxRow nxRowJustify="start,around">
      <div nxCol="12" style="text-align: center">
        <nx-icon name="check-circle" size="m" [style.color]="reqDecision ? 'green' : 'red'"></nx-icon>
      </div>
    </div>
    <div nxRow nxRowJustify="center" class="nx-margin-top-m nx-margin-bottom-s">
      <div nxCol="12">
        <h3 class="u-text-align-center" *ngIf="reqDecision" nxHeadline="subsection-xsmall">Approved successfully</h3>
        <h3 class="u-text-align-center" *ngIf="!reqDecision" nxHeadline="subsection-xsmall">Rejected successfully</h3>
      </div>
    </div>
    <div class="nx-margin-top-2m" nxRow nxRowJustify="center">
      <div nxCol="12">
        <button (click)="toggleClaimARModal()" nxButton="block primary">Close</button>
      </div>
    </div>
  </div>
</nx-modal>

<!-- Cases Modal -->
<nx-modal *ngIf="casesModalOpen" [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" [nxShowCloseIcon]="true" (nxClose)="closeCasesModal()">
  <div nxLayout="grid" class="cases-modal-content" style="margin-top: 2%">
    <div nxRow nxRowJustify="start,start,around">
      <div nxCol="12">
        <h2 class="cases-title">Expenditure Details</h2>
      </div>
    </div>

    <div nxRow *ngIf="casesHasError" nxRowJustify="center" class="nx-margin-top-s nx-margin-bottom-s">
      <div nxCol="12" style="text-align: center;">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">{{ casesErrorMessage }}</h3>
      </div>
    </div>

    <div nxRow *ngIf="!casesHasError && casesList.length === 0" nxRowJustify="center" class="nx-margin-top-s nx-margin-bottom-s">
      <div nxCol="12" style="text-align: center;">
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No cases found</h3>
      </div>
    </div>

    <div nxRow *ngIf="!casesHasError && casesList.length > 0">
      <div nxCol="12">
        <div class="cases-table-wrap nx-margin-top-s">
          <table nxTable zebra condensed>
            <thead>
              <tr nxTableRow>
                <th nxHeaderCell>S.No</th>
                <th nxHeaderCell>Expenditure Number</th>
                <th nxHeaderCell>Case Number</th>
                <th nxHeaderCell>Registration Number</th>
                <th nxHeaderCell>VIN</th>
                <th nxHeaderCell>Expenditure Type</th>
                <th nxHeaderCell>Service Type</th>
              </tr>
            </thead>
            <tbody>
              <tr nxTableRow *ngFor="let item of casesList; let i = index">
                <td nxTableCell>{{ i + 1 }}</td>
                <td nxTableCell>{{ item['Expenditure_Number'] }}</td>
                <td nxTableCell>{{ item['Case_Number'] }}</td>
                <td nxTableCell>{{ item['Registration_Number'] }}</td>
                <td nxTableCell>{{ item['VIN'] }}</td>
                <td nxTableCell>{{ item['Expenditure_Type'] }}</td>
                <td nxTableCell>{{ item['Service_Type'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</nx-modal>

<!-- Submit Claim Modal -->
<nx-modal *ngIf="claimFormModalOpen" [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" [nxShowCloseIcon]="false">
  <div nxLayout="grid" *ngIf="!isSuccess" style="margin-top: 2%">
    <div nxRow nxRowJustify="start,start,around">
      <div nxCol="12">
        <h1 style="text-align: center" nxHeadline="page">Dealer Claim Request</h1>
        <form [formGroup]="claimRequestForm">
          <div nxRow nxRowJustify="around">
            <div nxCol="12,12,12,6">
              <nx-formfield nxLabel="Claim Type">
                <nx-formfield-label class="required">Claim Type</nx-formfield-label>
                <nx-dropdown formControlName="claimType">
                  <nx-dropdown-item [nxValue]="ClaimTypes.Damage">Damage Claim</nx-dropdown-item>
                  <nx-dropdown-item [nxValue]="ClaimTypes.Technician">Technician Reimbursement</nx-dropdown-item>
                  <nx-dropdown-item [nxValue]="ClaimTypes.Towing">Towing Reimbursement</nx-dropdown-item>
                </nx-dropdown>
                <nx-error nxFormfieldError>
                  <div *ngIf="RequestFormControls.claimType.errors?.required"><strong>Please note:</strong> Select claim type.</div>
                </nx-error>
              </nx-formfield>
            </div>
            <div nxCol="12,12,12,6">
              <nx-label>Upload Invoice (PDF only) <strong style="color: red">*</strong></nx-label>
              <app-upload [acceptedfiles]="acceptedPdfType" (onUploadFinished)="onInvoiceUploadFinished($event)"></app-upload>
            </div>
          </div>
          <div nxRow nxRowJustify="around" *ngIf="claimRequestForm.get('claimType').value == ClaimTypes.Damage">
            <div nxCol="12">
              <nx-label>Upload Vehicle Images (optional)</nx-label>
              <app-upload [acceptedfiles]="acceptedImageType" (onUploadFinished)="onVehicleImageUploadFinished($event)"></app-upload>
            </div>
          </div>
          <div nxRow nxRowJustify="around">
            <div nxCol="12">
              <nx-formfield nxLabel="Remark">
                <textarea nxInput formControlName="remark" rows="2" cols="75" type="text"></textarea>
                <nx-error nxFormfieldError>
                  <div *ngIf="RequestFormControls.remark.errors?.pattern"><strong>Please note:</strong> Enter valid remark.</div>
                </nx-error>
              </nx-formfield>
            </div>
          </div>
          <div nxRow nxRowJustify="around">
            <div nxCol="12,12,8,6" nxColoffset="2" style="text-align: center">
              <button nxButton="cta" type="button" (click)="saveClaim()" [disabled]="checkClaimFormDisable">
                {{ saveClaimText }}
                <nx-spinner nxSize="medium" class="nx-margin-x-2xs" *ngIf="saveClaimInProgress"></nx-spinner>
              </button>
              <button nxButton="emphasis" type="button" (click)="toggleClaimFormModal()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div nxLayout="grid" *ngIf="isSuccess" style="margin-top: 2%">
    <div nxRow nxRowJustify="start,around">
      <div nxCol="12" style="text-align: center">
        <nx-icon name="check-circle" size="m" style="color: green"></nx-icon>
      </div>
    </div>
    <div nxRow nxRowJustify="start,around">
      <h3 class="u-text-align-center" nxHeadline="subsection-xsmall">Claim submitted successfully</h3>
    </div>
    <div class="nx-margin-top-2m" nxRow nxRowJustify="center">
      <div nxCol="12">
        <button (click)="toggleClaimFormModal()" nxButton="block primary">Close</button>
      </div>
    </div>
  </div>
</nx-modal>